export default __webpack_public_path__ + "static/media/24.b19043ae.jpg";